import { stateMap } from "../global/utils";

export const getSelectStates = (states) => {
    const map = stateMap();
    return states.map(state => {
        return {key: state, name: map[state]};
    });
}

export const getSelectedOrg = (orgs, orgId) => {
    const orgsIn = orgs;
    if (orgsIn) {
        const selected = orgsIn.filter(org => org.courtId === orgId);
        if (selected) return selected[0];
    }
    return null;
}

export const getPaymentTypes = (org) => {
    const types = [];
    if (org.nonCourtOrganization) {
        types.push({key: 'balances', description: 'Pay account balances'});
    } else {
        types.push({key: 'balances', description: 'Pay case/citation balances'});
    }
    if (org.enableMiscFees && !org.msFeesVtOnly) {
        types.push({key: 'miscFees', description: 'Pay miscellaneous fees'});
    }
    return types;
}

export const getSelectedType = (paymentTypes, key) => {
    const types = paymentTypes;
    if (types) {
        const selected = types.filter(type => type.key === key);
        if (selected) return selected[0];
    }
    return null;
}